export default __webpack_public_path__ + "static/main-app-landing-page-0728da0441a47974aed8814a4f06c4ab.png";